import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDiagonalArrowDownRight = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M5,6.41L6.41,5L17,15.59V9H19V19H9V17H15.59L5,6.41Z" })
});
export default SvgDiagonalArrowDownRight;
